import React from "react";

export default function EmptyState({ text }) {
  return (
    <div className="rounded-[16px] border border-dashed border-[#f2c6cc] bg-[#fffafb] px-4 py-8 text-center text-[14px] text-slate-500">
      {text}
    </div>
  );
}